import { Box, Grid, GridItem } from "@chakra-ui/react";
import React from "react";
import Header from "../header/";
import { color } from "../../utils/theme";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducer/rootReducer";

const Wrap = ({ children }: any) => {
  const user = useSelector((state: RootState) => state.user);

  // if not logged in we dont need to show the header
  if (!user.user) {
    return children;
  }

  return (
    <Box
      maxH="100%"
      w={"100%"}
      overflow={"hidde"}
      position={"absolute"}
      zIndex={10}
      color={color.text}
    >
      <Box>
        <Grid
          templateAreas={{
            base: '"header" "main" "footer"',
            sm: `"header" "main" "footer"`, // Add header to "main" for sm
            md: `"header" "main" "footer"`,
            lg: '"header" "main" "footer"',
            xl: '"header" "main" "footer"',
            "2xl": '"header" "main" "footer"',
          }}
          gridTemplateRows={{
            base: "100px 1fr 30px",
            sm: "100px 1fr 30px", // Adjust row height for header in sm
            md: "100px 1fr 30px",
            lg: "100px 1fr 30px",
            xl: "100px 1fr 30px",
            "2xl": "100px 1fr 30px",
          }}
          gridTemplateColumns={{
            base: "1fr",
            sm: "1fr",
            md: "1fr",
            lg: "1fr",
            xl: "1fr",
            "2xl": "100%",
          }}
          minH={"100vh"}
          color={color.text}
          textAlign={"center"}
          fontWeight="bold"
          rowGap={10}
          overflow="hidden" // Add this line to hide overflow
        >
          <GridItem
            area={"header"}
            sx={{
              backgroundColor: color,
              width: "100%",
              borderBottom: "1px solid #E2E8F0",
            }}
            style={{ position: "sticky", top: 0, zIndex: 10 }}
          >
            <Header />
          </GridItem>
          <GridItem
            area={"main"}
            position={"relative"}
            p={5}
            w={"100%"}
            overflow="hidden" // Add this line to enable scrolling for children
          >
            {children}
          </GridItem>
          <GridItem
            area={"footer"}
            position={"fixed"}
            width="100%"
            zIndex={2}
            bottom={"0"}
          ></GridItem>
        </Grid>
      </Box>
    </Box>
  );
};

export default Wrap;
